module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-cuisine-6f0067c926e54e4c833914353d8822d1.jpg";